itsoftApp.createModule("scrollActions", function () {
    var module = this;
    var queue = [];
    var loadingStarted = false;
    var moduleInitialized = false;
    var registeredPlugin = false;
    var headerHeight = itsoftApp.utils.getHeaderHeight();

    itsoftApp.modules.windowResize.addEvent(function () {
        headerHeight = itsoftApp.utils.getHeaderHeight();
    });

    var initScrollActions = function (element) {

        if (!registeredPlugin) {
            registeredPlugin = true;
            // регистрируем дополнительный плагин, чтобы анимации работали при скролле
            gsap.registerPlugin(ScrollTrigger);
        }

        if (typeof element === "function") {
            element();
        } else {
            if (element.classList.contains("js-scroll-text-start")) {
                var firstEnterFlag = false;

                gsap.utils.toArray(".js-scroll-text").forEach(function (item, i, arr) {
                    const els = item.querySelectorAll(".js-ordered-anim");

                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        onEnter: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("fadeInShow");
                                    el.classList.add("js-anim-active");
                                    if (!firstEnterFlag && i === els.length - 1) {
                                        if (el.classList.contains("js-number-section")) {
                                            setTimeout(function () {
                                                gsap.utils.toArray(els).forEach(function (numEl, j) {
                                                    numEl.classList.add("js-visible");
                                                    itsoftApp.modules.numbersAnimate.init(numEl);
                                                });
                                            });
                                        }
                                    }
                                }, i * 300);
                            });
                        },

                        onLeaveBack: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                if (el.classList.contains("contacts__map-wrapper")) {
                                    el.classList.remove("js-anim-active");
                                }
                            });
                        },

                        onEnterBack: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("fadeInShow");
                                    el.classList.add("js-anim-active");
                                    if (!firstEnterFlag && i === els.length - 1) {
                                        if (el.classList.contains("js-number-section")) {
                                            setTimeout(function () {
                                                gsap.utils.toArray(els).forEach(function (numEl, j) {
                                                    numEl.classList.add("js-visible");
                                                    itsoftApp.modules.numbersAnimate.init(numEl);
                                                });
                                            });
                                        }
                                    }
                                }, i * 300);
                            });
                        }
                    });
                });

                gsap.utils.toArray(".js-scroll-numbers").forEach(function (item, i, arr) {
                    const els = item.querySelectorAll(".js-number-section");

                    ScrollTrigger.create({
                        trigger: ".js-scroll-numbers",
                        start: "top center",
                        end: "bottom center",
                        onEnter: function () {
                            if (firstEnterFlag) {
                                gsap.utils.toArray(els).forEach(function (el, i) {
                                    if (el.classList.contains("js-number-section") && !(el.classList.contains("js-visible"))) {
                                        el.classList.add("js-visible");
                                        itsoftApp.modules.numbersAnimate.init(el);
                                    }
                                });
                            }
                        },

                        onLeaveBack: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                if (el.classList.contains("js-number-section") && el.classList.contains("js-visible")) {
                                    var numberTargets = document.querySelectorAll("[data-number-target]");
                                    Array.prototype.forEach.call(numberTargets, function (number) {
                                        if (number.classList.contains("figures__year")) {
                                            number.textContent = "2021";
                                        } else {
                                            number.textContent = "0";
                                        }
                                    });
                                    el.classList.remove("js-visible");
                                }
                            });
                        },

                        onLeave: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                if (el.classList.contains("js-number-section") && el.classList.contains("js-visible")) {
                                    var numberTargets = document.querySelectorAll("[data-number-target]");
                                    Array.prototype.forEach.call(numberTargets, function (number) {
                                        if (number.classList.contains("figures__year")) {
                                            number.textContent = "2021";
                                        } else {
                                            number.textContent = "0";
                                        }
                                    });
                                    el.classList.remove("js-visible");
                                }
                            });
                        },

                        onEnterBack: function () {
                            if (firstEnterFlag) {
                                gsap.utils.toArray(els).forEach(function (el, i) {
                                    if (el.classList.contains("js-number-section") && !(el.classList.contains("js-visible"))) {
                                        el.classList.add("js-visible");
                                        itsoftApp.modules.numbersAnimate.init(el);
                                    }
                                });
                            }
                        }
                    });
                });

                gsap.utils.toArray(".js-scroll-text-fast").forEach(function (item, i, arr) {
                    const els = item.querySelectorAll(".js-ordered-anim");

                    ScrollTrigger.create({
                        trigger: item,
                        start: "top 75%",
                        end: "bottom 75%",
                        onEnter: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("fadeInShow");
                                    el.classList.add("js-anim-active");

                                    if (el.classList.contains("js-number-section") && !(el.classList.contains("js-visible"))) {
                                        el.classList.add("js-visible");
                                        setTimeout(function () {
                                            itsoftApp.modules.numbersAnimate.init(el);
                                        }, 300);
                                    }
                                }, i * 300);
                            });
                        },

                        onEnterBack: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("fadeInShow");
                                    el.classList.add("js-anim-active");
                                    if (el.classList.contains("js-number-section") && !(el.classList.contains("js-visible"))) {
                                        el.classList.add("js-visible");
                                        setTimeout(function () {
                                            itsoftApp.modules.numbersAnimate.init(el);
                                        }, 300);
                                    }
                                }, i * 300);
                            });
                        },

                        onLeaveBack: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                if (el.classList.contains("contacts__map-wrapper")) {
                                    el.classList.remove("js-anim-active");
                                }
                            });
                        }
                    });
                });

                const els = document.querySelectorAll(".about__figures .js-ordered-anim");

                ScrollTrigger.create({
                    trigger: ".about__figures",
                    start: "top bottom",
                    end: "bottom top",

                    onLeaveBack: function () {
                        gsap.utils.toArray(els).forEach(function (el, i) {
                            if (el.classList.contains("js-number-section") && el.classList.contains("js-visible")) {
                                var numberTargets = document.querySelectorAll("[data-number-target]");
                                Array.prototype.forEach.call(numberTargets, function (number) {
                                    if (number.classList.contains("is-completed")) {
                                        if (number.classList.contains("figures__year")) {
                                            number.textContent = "2021";
                                        } else {
                                            number.textContent = "0";
                                        }
                                    }
                                });
                                el.classList.remove("js-visible");
                            }
                        });
                    },

                    onLeave: function () {
                        gsap.utils.toArray(els).forEach(function (el, i) {
                            if (el.classList.contains("js-number-section") && el.classList.contains("js-visible")) {
                                var numberTargets = document.querySelectorAll("[data-number-target]");
                                Array.prototype.forEach.call(numberTargets, function (number) {
                                    if (number.classList.contains("is-completed")) {
                                        if (number.classList.contains("figures__year")) {
                                            number.textContent = "2021";
                                        } else {
                                            number.textContent = "0";
                                        }
                                    }
                                });
                                el.classList.remove("js-visible");
                            }
                        });
                    },
                });

                gsap.utils.toArray(".js-block-anim").forEach(function (item, i, arr) {
                    ScrollTrigger.create({
                        trigger: item,
                        start: "top 90%",
                        end: "bottom 90%",
                        onEnter: function () {
                            item.classList.add("is-active");
                            var textBlocks = item.querySelectorAll(".js-block-text");

                            var fade = item.querySelector(".fadeInUpTransition");

                            if (fade) {
                                fade.classList.add("fadeInShow");
                            }

                            gsap.utils.toArray(textBlocks).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("js-anim-active");
                                }, i * 300 + 500);
                            });
                        }
                    });
                });
            }

            if (element.classList.contains("js-scroll-anchor-start")) {
                const anchorSections = document.querySelectorAll(".js-scroll-anchor");

                gsap.utils.toArray(".js-scroll-anchor").forEach(function (item, i, arr) {
                    const anchor = "#" + item.id;
                    const menu = document.querySelector(".main-menu");
                    const links = menu.querySelectorAll("[href='" + anchor + "']" );

                    ScrollTrigger.create({
                        trigger: item,
                        start: "top 40%",
                        end: "bottom 40%",
                        onEnter: function () {
                            if (item.classList.contains("divisions")) {
                                var fixed = document.querySelector(".page__fixed-icons");

                                if (fixed) {
                                    fixed.classList.add("is-active");
                                }
                            }

                            if (item.id === "about") {
                                var toTop = document.querySelector(".js-to-top");

                                if (toTop) {
                                    toTop.classList.add("is-active");
                                }
                            }

                            history.replaceState("", "", "./#" + item.id);

                            var activeMenuItems = document.querySelectorAll(".js-anchor-item.is-active");

                            if (activeMenuItems.length > 0) {
                                Array.prototype.forEach.call(activeMenuItems, function (activeMenuItem) {
                                    activeMenuItem.classList.remove("is-active");
                                });
                            }

                            gsap.utils.toArray(links).forEach(function (link) {
                                if (link.hasAttribute("data-href")) {
                                    var elLink = link.getAttribute("data-href");
                                    var elHref = "[href='" + elLink + "']";
                                    var linkHref = menu.querySelector(elHref);
                                    linkHref.closest(".js-anchor-item").classList.add("is-active");
                                }

                                link.closest(".js-anchor-item").classList.add("is-active");
                            })
                        },
                        onEnterBack: function () {
                            var activeMenuItems = document.querySelectorAll(".js-anchor-item.is-active");

                            if (activeMenuItems.length > 0) {
                                Array.prototype.forEach.call(activeMenuItems, function (activeMenuItem) {
                                    activeMenuItem.classList.remove("is-active");
                                });
                            }

                            gsap.utils.toArray(links).forEach(function (link) {
                                if (link.hasAttribute("data-href")) {
                                    var elLink = link.getAttribute("data-href");
                                    var elHref = "[href='" + elLink + "']";
                                    var linkHref = menu.querySelector(elHref);
                                    linkHref.closest(".js-anchor-item").classList.add("is-active");
                                }

                                link.closest(".js-anchor-item").classList.add("is-active");
                            });

                            history.replaceState("", "", "./#" + item.id);
                        },
                        // onLeave: function () {
                        //     gsap.utils.toArray(links).forEach(function (link) {
                        //         link.closest(".main-menu__item").classList.remove("is-active");
                        //     })
                        // },
                        onLeaveBack: function () {
                            // gsap.utils.toArray(links).forEach(function (link) {
                            //     link.closest(".main-menu__item").classList.remove("is-active");
                            // })

                            if (item.classList.contains("divisions")) {
                                var fixed = document.querySelector(".page__fixed-icons");

                                var activeMenuItems = document.querySelectorAll(".js-anchor-item.is-active");

                                if (activeMenuItems.length > 0) {
                                    Array.prototype.forEach.call(activeMenuItems, function (activeMenuItem) {
                                        activeMenuItem.classList.remove("is-active");
                                    });
                                }

                                var mainLink = document.querySelector("a[href='#intro'].js-anchor");

                                if (mainLink) {
                                    var mainItem = mainLink.closest(".js-anchor-item");

                                    if (mainItem) {
                                        mainItem.classList.add("is-active");
                                    }
                                }

                                if (fixed) {
                                    fixed.classList.remove("is-active");
                                }

                                history.replaceState("", "", "./");
                            }

                            if (item.id === "about") {
                                var toTop = document.querySelector(".js-to-top");

                                if (toTop) {
                                    toTop.classList.remove("is-active");
                                }
                            }
                        }
                    });
                });
            }
        }
    }

    var initScrollLibrary = function (element) {

        if (!moduleInitialized) {
            queue.push(element);

            if (!loadingStarted) {
                loadingStarted = true;
                itsoftApp.loadScript("/assets/scripts/gsap/gsap.min.js", function () {
                    itsoftApp.loadScript("/assets/scripts/gsap/ScrollTrigger.min.js", function () {
                        moduleInitialized = true;
                        while (queue.length > 0) {
                            initScrollActions(queue.shift());
                        }
                    });
                });
            }
        } else {
            initScrollActions(element);
        }
    };

    module.callback = initScrollLibrary;
});